import {IntlKeyValuePair, IntlNamespaces} from "./types";

export const INTL_ADD_PHONE_NUMBER_MESSAGE: IntlKeyValuePair = {
    key: "addPhoneNumberMessage",
    defaultValue: "Please provide your phone number to receive notifications",
    intlValue: "Please provide your phone number to receive notifications",
    namespace: IntlNamespaces.CHAT,
};

export const INTL_NOTIFICATION_MESSAGE: IntlKeyValuePair = {
    key: "notificationMessage",
    defaultValue: "You will receive a notification",
    intlValue: "You will receive a notification",
    namespace: IntlNamespaces.CHAT,
};

export const INTL_HAS_APPLIED_QUESTION: IntlKeyValuePair = {
    key: "hasAppliedQuestion",
    defaultValue: "Have you already applied to",
    intlValue: "Have you already applied to",
    namespace: IntlNamespaces.CHAT,
};

export const INTL_NOT_YET: IntlKeyValuePair = {
    key: "notYet",
    defaultValue: "not yet",
    intlValue: "not yet",
    namespace: IntlNamespaces.CHAT,
};

export const INTL_YES: IntlKeyValuePair = {
    key: "yes",
    defaultValue: "yes",
    intlValue: "yes",
    namespace: IntlNamespaces.CHAT,
};

export const INTL_REPLY_LATER: IntlKeyValuePair = {
    key: "replyLater",
    defaultValue: (name: string) => `${name} will reply in under 24h`,
    intlValue: "{{name}} will reply in under 24h",
    namespace: IntlNamespaces.CHAT,
};

export const INTL_ADD: IntlKeyValuePair = {
    key: "add",
    defaultValue: "Add",
    intlValue: "Add",
    namespace: IntlNamespaces.CHAT,
};

export const INTL_QSS_QUESTION_TITLE: IntlKeyValuePair = {
    key: "qssQuestionTitle",
    defaultValue: "Here are some ideas... or ask your own :)",
    intlValue: "Here are some ideas... or ask your own :)",
    namespace: IntlNamespaces.CHAT,
};

export const INTL_CONVERSATION_WITH: IntlKeyValuePair = {
    key: "conversationWith",
    defaultValue: (name: string) => `Conversation with ${name}`,
    intlValue: "Conversation with {{name}}",
    namespace: IntlNamespaces.CHAT,
};

export const INTL_SECURE_AND_ANONYMISED_MESSAGE: IntlKeyValuePair = {
    key: "secureAndAnonymisedMessage",
    defaultValue: "Messages you send to this chat are secure and kept anonymised.",
    intlValue: "Messages you send to this chat are secure and kept anonymised.",
    namespace: IntlNamespaces.CHAT,
};

export const INTL_READ: IntlKeyValuePair = {
    key: "read",
    defaultValue: "Read",
    intlValue: "Read",
    namespace: IntlNamespaces.CHAT,
};

export const INTL_DELIVERED: IntlKeyValuePair = {
    key: "delivered",
    defaultValue: "Delivered",
    intlValue: "Delivered",
    namespace: IntlNamespaces.CHAT,
};

export const INTL_SEND: IntlKeyValuePair = {
    key: "send",
    defaultValue: "Send",
    intlValue: "Send",
    namespace: IntlNamespaces.CHAT,
};

export const INTL_TYPE_HERE: IntlKeyValuePair = {
    key: "typeHere",
    defaultValue: "Type here...",
    intlValue: "Type here...",
    namespace: IntlNamespaces.CHAT,
};

export const INTL_CHAT_NOW: IntlKeyValuePair = {
    key: "chatNow",
    defaultValue: "Start chatting now",
    intlValue: "Start chatting now",
    namespace: IntlNamespaces.CHAT,
};

export const INTL_GET_NOTIFIED: IntlKeyValuePair = {
    key: "getNotified",
    defaultValue: (name: string) => `Ask ${name} your question and get notified when they reply`,
    intlValue: "Ask {{name}} your question and get notified when they reply",
    namespace: IntlNamespaces.CHAT,
};

export const INTL_CREATE_ACCOUNT: IntlKeyValuePair = {
    key: "createAccount",
    defaultValue: "Create your account",
    intlValue: "Create your account",
    namespace: IntlNamespaces.CHAT,
};

export const INTL_GO_BACK: IntlKeyValuePair = {
    key: "goBack",
    defaultValue: "Go back",
    intlValue: "Go back",
    namespace: IntlNamespaces.CHAT,
};

export const INTL_GO_BACK_TO_INBOX: IntlKeyValuePair = {
    key: "goBackToInbox",
    defaultValue: "Go back to Inbox List",
    intlValue: "Go back to Inbox List",
    namespace: IntlNamespaces.CHAT,
};

export const INTL_MENTOR_PROFILE: IntlKeyValuePair = {
    key: "mentorProfile",
    defaultValue: (name: string) => `Profile of ${name}`,
    intlValue: "Profile of {{name}}",
    namespace: IntlNamespaces.CHAT,
};

export const INTL_SMS: IntlKeyValuePair = {
    key: "sms",
    defaultValue: "SMS",
    intlValue: "SMS",
    namespace: IntlNamespaces.CHAT,
};

export const INTL_WHATSAPP: IntlKeyValuePair = {
    key: "whatsapp",
    defaultValue: "WhatsApp",
    intlValue: "WhatsApp",
    namespace: IntlNamespaces.CHAT,
};

export const INTL_SIGN_UP_TO_CHAT: IntlKeyValuePair = {
    key: "signUpToChat",
    defaultValue: "Sign up to start chatting",
    intlValue: "Sign up to start chatting",
    namespace: IntlNamespaces.CHAT,
};

export const INTL_REPLY_NOTIFICATION_PROMPT: IntlKeyValuePair = {
    key: "replyNotificationPrompt",
    defaultValue: (name: string) =>
        `Send your question and we'll let you know when ${name} replies.`,
    intlValue: "Send your question and we'll let you know when {{name}} replies.",
    namespace: IntlNamespaces.CHAT,
};

export const INTL_SIGN_UP_TO_GET_REPLY: IntlKeyValuePair = {
    key: "signUpToGetReply",
    defaultValue: (name: string) => `Sign up to receive ${name}'s response!`,
    intlValue: "Sign up to receive {{name}}'s response!",
    namespace: IntlNamespaces.CHAT,
};

export const INTL_SIGN_UP_TO_GET_REPLY_PROMPT: IntlKeyValuePair = {
    key: "signUpToGetReplyPrompt",
    defaultValue: (name: string) => `We’ll let you know as soon as ${name} replies.`,
    intlValue: "We’ll let you know as soon as {{name}} replies",
    namespace: IntlNamespaces.CHAT,
};

export const INTL_SIGN_UP: IntlKeyValuePair = {
    key: "signUp",
    defaultValue: "Sign up",
    intlValue: "Sign up",
    namespace: IntlNamespaces.CHAT,
};

export const INTL_SIGN_UP_WITH_EMAIL: IntlKeyValuePair = {
    key: "signUpWithEmail",
    defaultValue: "Sign up with email",
    intlValue: "Sign up with email",
    namespace: IntlNamespaces.CHAT,
};
